module.exports = __webpack_public_path__ + "img/i-6.589d885f.svg";